import { CtaCard } from '@app/components/blocks/card/CtaCard'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { useTranslations } from '@i18n/useLanguage'
import { pages } from '@app/util/links'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import useMediaQuery from '@app/util/useMediaQuery'

const CALENDLY_URL =
  'https://calendly.com/bela-crowdbuilding/gesprek-met-crowdbuilding'

export const FinishStep = () => {
  const t = useTranslations().app.dashboard.initiative.creation
  const isMobile = useMediaQuery()

  return (
    <Column
      gap="2.5rem"
      alignItems="center"
      style={{ width: '100%', justifyContent: 'center' }}
    >
      <Row>
        <Column
          gap="1rem"
          alignItems="center"
          style={{ textAlign: 'center', maxWidth: '30rem' }}
        >
          <Title.H2 style={{ color: 'var(--brand-secondary)' }}>
            {t.initiativeOnlineTitle}
          </Title.H2>
          <Text.Medium color="var(--brand-secondary)">
            {t.initiativeOnlineDescription}
          </Text.Medium>
        </Column>
      </Row>
      <Row
        gap="1rem"
        alignItems="stretch"
        style={{
          width: '100%',
          flexDirection: isMobile ? 'column' : 'row',
        }}
      >
        <CtaCard
          title={t.eLearningCardTitle}
          subtitle={t.eLearningCardDescription}
          linkText={t.eLearningCardLinkLabel}
          linkHref={pages.elearning}
          linkAsButton
          buttonVariant="secondary"
          border
          alignLinkToBottom
          style={{ padding: '1.5rem 1rem', flex: 1 }}
        />
        <CtaCard
          title={t.knowledgeHubCardTitle}
          subtitle={t.knowledgeHubCardDescription}
          linkText={t.knowledgeHubCardLinkLabel}
          linkHref={pages.knowledgeHub}
          linkAsButton
          buttonVariant="secondary"
          border
          alignLinkToBottom
          style={{ padding: '1.5rem 1rem', flex: 1 }}
        />
        <CtaCard
          title={t.meetingCardTitle}
          subtitle={t.meetingCardDescription}
          linkText={t.meetingCardLinkLabel}
          linkOnClick={() => window.open(CALENDLY_URL, '_blank', 'noopener')}
          linkAsButton
          buttonVariant="secondary"
          border
          alignLinkToBottom
          style={{ padding: '1.5rem 1rem', flex: 1 }}
        />
      </Row>
    </Column>
  )
}
